import React, { useEffect, useState } from "react";
import { PhoneCall, ChevronLeft, ChevronRight } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const CARD = "bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)]";
const shift = (m, d) => { const [y, mo] = m.split("-").map(Number); const x = new Date(y, mo - 1 + d, 1); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}`; };
const label = (m) => { const [y, mo] = m.split("-").map(Number); return new Date(y, mo - 1, 1).toLocaleDateString("en-GB", { month: "long", year: "numeric" }); };

export const CellCallReport = () => {
  const [month, setMonth] = useState(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; });
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/cell/call-report?month=${month}`).then(({ data }) => setData(data)).catch(() => { toast.error("Couldn't load call activity"); setData({ rows: [], total_calls: 0 }); });
  }, [month]);
  return (
    <div className={`${CARD} p-6`} data-testid="cell-call-report">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h2 className="font-head text-lg font-bold flex items-center gap-2"><PhoneCall className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> Call activity</h2>
        <div className="flex items-center gap-1">
          <button data-testid="cell-call-report-prev" onClick={() => setMonth(shift(month, -1))} className="p-1.5 rounded-full hover:bg-[#EDF2F4]" aria-label="Previous month"><ChevronLeft className="h-4 w-4" /></button>
          <span className="text-sm font-semibold w-36 text-center" data-testid="cell-call-report-month">{label(month)}</span>
          <button data-testid="cell-call-report-next" onClick={() => setMonth(shift(month, 1))} className="p-1.5 rounded-full hover:bg-[#EDF2F4]" aria-label="Next month"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      {!data ? <p className="text-sm" style={{ color: "var(--sj-text-3)" }} data-testid="cell-call-report-loading">Loading…</p> : !data.rows.length ? <p className="text-sm" style={{ color: "var(--sj-text-3)" }} data-testid="cell-call-report-empty">No Cell Group calls made through the app this month.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider" style={{ color: "var(--sj-text-3)" }}><th className="py-2 pr-3">Host / leader</th><th className="py-2 px-3 text-right">Calls</th><th className="py-2 px-3 text-right">People</th><th className="py-2 px-3 text-right">Spoke</th><th className="py-2 pl-3 text-right">Notes added</th></tr></thead>
            <tbody>
              {(data?.rows || []).map((r, i) => (
                <tr key={i} className="border-t border-[#EBE9E4]" data-testid={`cell-call-report-row-${i}`}>
                  <td className="py-2 pr-3 font-medium">{r.author || "Unknown"}</td>
                  <td className="py-2 px-3 text-right font-bold" style={{ color: "var(--sj-primary)" }}>{r.calls}</td>
                  <td className="py-2 px-3 text-right">{r.people}</td>
                  <td className="py-2 px-3 text-right">{r.spoke}</td>
                  <td className="py-2 pl-3 text-right">{r.noted}</td>
                </tr>
              ))}
            </tbody>
            {data?.rows?.length > 0 && <tfoot><tr className="border-t-2 border-[#EBE9E4] font-semibold"><td className="py-2 pr-3">Total</td><td className="py-2 px-3 text-right" data-testid="cell-call-report-total">{data.total_calls}</td><td colSpan={3} /></tr></tfoot>}
          </table>
        </div>
      )}
    </div>
  );
};
